<template>
  <card>
    <template slot="header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Datos de Seguimiento</h3>
        </div>

        <div class="col text-right">
          <router-link
            v-if="(!plot.isShare && $can('update', 'plots')) || (plot.isShare && plot.write)"
            :to="{ name: 'PlotFollowUp', params: { id: plot.id } }"
            class="btn btn-outline-primary btn-sm"
          >
            <i class="fas fa-pen"></i>&nbsp;Modificar
          </router-link>
          <button class="btn btn-outline-dark btn-sm" @click="getPdf"><i class="fas fa-download"></i>&nbsp;PDF</button>
        </div>
      </div>
    </template>

    <div class="d-flex flex-wrap content-info">
      <div class="info-block bg-image"></div>

      <div class="info-block bg-text m-4">
        <trace-resume v-if="hasPreEmergence || hasEmergence || hasHarvest" :plot="plot"> </trace-resume>

        <div v-if="!hasPreEmergence">Sin datos cargados</div>
      </div>
    </div>
  </card>
</template>

<script>
import TraceResume from '../Widgets/TraceResume';

export default {
  components: {
    TraceResume,
  },

  props: {
    plot: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasPreEmergence() {
      return Boolean(this.plot.preEmergence);
    },

    hasEmergence() {
      return Boolean(this.plot.emergence);
    },

    hasHarvest() {
      return Boolean(this.plot.harvest);
    },
  },

  methods: {
    getPdf() {
      let plot = `${this.plot.id}`.padStart(6, '0');
      let filename = `Resumen Lote-${plot}.pdf`;
      this.$services.resource('plots').getPdf(this.plot.id, filename);
    },
  },
};
</script>

<style lang="scss" scoped>
$pictures: 'https://images.unsplash.com/12/green.jpg?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80',
  'https://images.unsplash.com/reserve/22gQ9dqRziaAoZeBpZVY_kornmark-01.png?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1530464684439-723262c0d16e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1418995231169-b6d53c7cdbac?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1501255184224-b8e069bca278?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80',
  'https://images.unsplash.com/photo-1483871788521-4f224a86e166?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1501221092638-57857602d8bc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1499452565718-6a1fcb7d2001?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1491372770658-8db4fb88f70b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1470422048986-1f71bdffd485?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1527847263472-aa5338d178b8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1506732176389-db44ff3b5c91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1541622369845-d7a8d62103a2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1536261971452-3e2878a6509f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1511735643442-503bb3bd348a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1530267981375-f0de937f5f13?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1506884722919-3d990332a451?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1533572244028-557577ae1083?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1532011461890-eeeeae55597f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1530655937400-7f00928c51e1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1523486967874-06655b79331e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1520530453256-2132890f5942?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=60',
  'https://images.unsplash.com/photo-1470687372616-d48d122e3b06?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80',
  'https://images.unsplash.com/photo-1418995231169-b6d53c7cdbac?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80',
  'https://images.unsplash.com/photo-1528027218481-3b0120701ba8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjY1MDE0fQ&auto=format&fit=crop&w=1000&q=80',
  'https://images.unsplash.com/photo-1471289660181-7feae98d61ae?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80',
  'https://images.unsplash.com/photo-1542214970-beb9fc929948?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80';

$imgKey: random(length($pictures));
$nth: nth($pictures, $imgKey);

::v-deep .card-body {
  /*padding: 0 !important;*/
  height: 1400px;
  overflow: hidden;
}

.content-info {
  width: 100%;
  height: 100%;
  position: relative;
}

.info-block {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.bg-image {
  /* The image used */
  background-image: url('#{$nth}');
  opacity: 0.7;

  /* Add the blur effect */
  filter: blur(8px);
  -webkit-filter: blur(8px);

  /* Full height */
  width: 100%;
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* Position text in the middle of the page/image */
.bg-text {
  width: 95%;
  height: 95%;
  padding: 1rem;
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/opacity/see-through */
  color: #ffffff !important;
  border: 3px solid #f1f1f1;
  z-index: 2;
  overflow: hidden;
  overflow-y: scroll;
}

::v-deep .trace-resume {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6 {
    color: #ffffff !important;
  }

  h3,
  .h3 {
    font-size: 1.25rem;
  }

  p {
    font-size: 1.1rem;
  }
}
</style>
